export const statusCode = {
    waiting_for_online_payment_detail: -1,
    pending: 0,
    accepted: 1,
    en_route: 2,
    completed: 3,
    canceled: 4,
    delivered: 5,
    in_substitution: 6,
    in_edit: 8,
    online_payment_failed: 7,
    ready_for_checkout: 9,
    waiting_payment_approval: 10,
    ready_to_deliver: 11,
    checking_out: 12,
    payment_approved: 13,
    payment_rejected: 14
}

export const statusText: any = {
    0: 'Pending',
    1: 'Accepted',
    2: 'En Route',
    3: 'Completed',
    4: 'Cancelled',
    5: 'Delivered',
    6: 'In Substitution',
    7: 'Online Payment Failed',
    8: 'In Edit',
    9: 'Ready For Checkout',
    10: 'Waiting Payment Approval',
    11: 'Ready To Deliver',
    12: 'Checking Out',
    13: 'Payment Approved',
    14: 'Payment Rejected'
}

export const colors: any = {
    green: 'green',
    yellow: 'yellow',
    red: 'red',
}

export const sortColors: any = {
    default: 0,
    green: 1,
    red: 2,
}

export const roles: any = {
    Supervisor: 4,
    SuperUser: 5,
    FleetSupervisor: 11,
    CustomerSupport: 12,
    picker:1,
    checkout:2,
    CustomerSupportAdmin:13,
}